<div class="offcanvas-header">
  <h5 class="offcanvas-title">
    <i class="fa-solid fa-info-circle home-log me-2"></i
    >{{ "Home.ViewLogs" | translate }} ({{ logCount$ | async }})
  </h5>
  <button
    type="button"
    class="btn-close text-reset p-0 m-0"
    aria-label="Close"
    (click)="activeOffcanvas.dismiss('Cross click')"
  ></button>
</div>

<div class="offcanvas-body overflow-auto">
  @for (issue of logError$ | async; track issue) {
    <div class="log-entry mb-3" [ngClass]="issue.severity">
      <div class="d-flex">
        <div>
          <i class="fa-solid me-2" [ngClass]="icon[issue.severity]"></i>
        </div>
        <div>
          <div class="title">{{ getTitle(issue) }}</div>
          <div class="desc overflow-auto">{{ getDescription(issue) }}</div>
        </div>
      </div>
    </div>
  }
</div>
